import React from 'react';
import { Box } from '@mui/material';

import { ProductGroupSelectEnhancedContainer as ProductGroupSelect } from './ProductGroupSelectEnhanced/ProductGroupSelectEnhancedContainer';

import { ButtonGroup } from '../../ButtonGroup';
import { State } from '../redux';

type ComponentState = State['emConfiguration']['totalSpendOnTransaction'];
type Fields = keyof ComponentState;
export type Props = ComponentState & {
  editMode: boolean;
  fieldDisabled: (field: Fields) => boolean;
};

const TotalSpendOnTransactionConfiguration: React.FC<Props> = (props) => {
  const { editMode, ineligibleProductGroups, fieldDisabled, roundMoneyAmount } = props;

  return (
    <Box>
      <Box mb={4}>
        <ButtonGroup
          label='Round Money Amount'
          name='roundMoneyAmount'
          readonly={fieldDisabled('roundMoneyAmount')}
          selectedValue={roundMoneyAmount}
        >
          <ButtonGroup.Option value='half_up'>Half Up</ButtonGroup.Option>
          <ButtonGroup.Option value='down'>Down</ButtonGroup.Option>
          <ButtonGroup.Option value='raw'>Raw</ButtonGroup.Option>
        </ButtonGroup>
      </Box>

      <Box mb={4}>
        <ProductGroupSelect
          editMode={editMode}
          label='Excluded Product Groups'
          onChange={() => {}}
          readonly={fieldDisabled('ineligibleProductGroups')}
          selectedProductGroups={ineligibleProductGroups}
          ineligibleType={true}
        />
      </Box>
    </Box>
  );
};

export { TotalSpendOnTransactionConfiguration };
